module.exports = __webpack_public_path__ + "static/media/white-factory.0358c2ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/white-factory.svg
// module id = 307
// module chunks = 0